import type { FromModel } from "@/__main__/data-model.mjs";
import createModel from "@/__main__/data-model.mjs";
import {
  normalizeUserSubscription,
  userSubscriptionModel,
} from "@/feature-wallet/models/user-subscriptions.mjs";

export const CreateProSubscriptionModel = createModel({
  data: { subscribeToPlan: userSubscriptionModel },
}).transform(userSubscriptionModel, (data) =>
  normalizeUserSubscription(data.data.subscribeToPlan),
);

export type CreateProSubscription = FromModel<
  typeof CreateProSubscriptionModel
>;
